module.exports = __webpack_public_path__ + "static/media/transcript-arrow.07d3fa25.svg";